// API client para reportes dash (público, sin JWT)
import axios from 'axios'

// En producción: URL completa al backend. En dev: proxy de Vite.
const BASE_URL = import.meta.env.PROD
  ? `${import.meta.env.VITE_API_URL}/api/v2/dash`
  : '/api/v2/dash'

const dashClient = axios.create({
  baseURL: BASE_URL,
})

export async function fetchDashReport<T = Record<string, unknown>>(endpoint: string): Promise<T> {
  const { data } = await dashClient.get<T>(`/${endpoint}`)
  return data
}
